import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import JsonView from 'react18-json-view';
import 'react18-json-view/src/style.css';

import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  PageIcon,
  PageDescription,
  ContentGrid,
  ContentRow,
  Card,
  CardTitle,
  CardContent,
  ActionBar,
  Button,
  SearchInput,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusBadge,
  TabContainer,
  TabList,
  Tab,
  TabContent,
  fadeIn,
  Input,
  SubSectionTitle,
  Divider,
  formatString,
  useGoBack
} from '../styles/PageStyles';
import { get } from '../utils/apiUtils';
import { getAllEntitiesByFilter, listAllEntities } from "../services/entityService";
import { faBackspace, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



const EntityRecords = () => {

  const { entityId } = useParams();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [entityList, setEntityList] = useState([]);
  const [editableData, setEditableData] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const goBack = useGoBack();


  // Fetch user data on component load
  useEffect(() => {
    const fetchEntityData = async () => {
      let userData = JSON.parse(localStorage.getItem('userData'));
      let tableName = entityId.toLowerCase().replace(/ /g, "_") + "_" + userData.companyCd.toLowerCase();
      const filters = {};
      const sort = {};
      try {
        const response = await listAllEntities(tableName, filters, sort);
        setEntityList(response || []);
        setEditableData(response || []); // Initialize editable data
      } catch (error) {
        console.error('Error fetching user data:', error);
        navigate('/login'); // Redirect to login if unauthorized
      }
    };
    if (entityId) {
      fetchEntityData();
    }
  }, [navigate, entityId]);

  // Handle input changes in the editable grid
  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...editableData];
    updatedData[rowIndex][field] = value;
    setEditableData(updatedData);
  };

  // Save changes (example function)
  const handleSaveChanges = () => {
    console.log('Updated Data:', editableData);
    // Add logic to save the updated data to the server
  };
  const excludedFields = ['id', 'company_cd', 'created_by', 'created_at', 'updated_at', 'updated_by'];


  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'ACTIVE': return 'active';
      case 'INACTIVE': return 'active';
      case 'archived': return 'default';
      case 'disconnected': return 'error';
      default: return 'default';
    }
  };
  // Utility function to format date
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-GB');
  };




  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeaderWithInfo
          icon={faBackspace}
          goBack={true}
          title={entityId}
          description="The Entity page is designed to manage the knowledge sources and documents that power AI agents."
        >
          <div style={{ display: 'flex', gap: "1rem" }}>
            <SearchInput
              type="text"
              placeholder="Search Entities..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {/* <Button primary onClick={() => handleViewEntity('0')}>Add Entity</Button> */}
          </div>
        </PageHeaderWithInfo>
       


        <Card>
          <div style={{ overflowX: 'auto', width: '100%' }}>

            <Table>
              <thead>
                <tr>
                  {entityList.length > 0 &&
                    Object.keys(entityList[0])
                      .filter((key) => !excludedFields.includes(key))
                      .filter((key) => !Array.isArray(entityList[0][key])) // Exclude keys with array values
                      .map((key) => (
                        <TableHeader key={key}>{key.replace(/_/g, ' ')}</TableHeader>
                      ))}
                  {/* <TableHeader style={{ position: 'sticky', right: 0, background: '#fff', zIndex: 1 }}>Actions</TableHeader> */}
                </tr>
              </thead>
              <tbody>
                {console.log(editableData)}
                {editableData.map((row, rowIndex) => (
                  <TableRow key={rowIndex} onClick={(e) => { setIsDrawerOpen(true); setSelectedEntity(row) }}>
                    {console.log(row)}
                    {Object.keys(row)
                      .filter((key) => !excludedFields.includes(key))
                      .filter((key) => !Array.isArray(row[key]))
                      .map((field) => (
                        <>
                          <TableCell key={field} style={{ cursor: 'pointer', verticalAlign: 'top' }}>
                            {typeof row[field] === 'string' || typeof row[field] === 'number' || typeof row[field] === 'boolean' ? (
                              <span style={{ maxWidth: "175px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {row[field]}
                              </span>
                            ) : Array.isArray(row[field]) ? (
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                                {row[field].map((item, idx) => (
                                  <div
                                    key={idx}
                                    style={{
                                      border: '1px solid #e0e0e0',
                                      borderRadius: '6px',
                                      padding: '0.5rem',
                                      minWidth: '120px',
                                      background: '#fafafa',
                                      marginBottom: '0.5rem'
                                    }}
                                  >
                                    {typeof item === 'object' && item !== null ? (
                                      Object.entries(item).map(([k, v]) => (
                                        <div key={k} style={{ fontSize: '0.95em', marginBottom: '0.2em' }}>
                                          <b>{formatString(k)}:</b> {typeof v === 'object' ? JSON.stringify(v) : String(v)}
                                        </div>
                                      ))
                                    ) : (
                                      <span>{String(item)}</span>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ) : typeof row[field] === 'object' && row[field] !== null ? (
                              <div>
                                {Object.entries(row[field]).map(([k, v]) => (
                                  <div key={k} style={{ fontSize: '0.95em', marginBottom: '0.2em' }}>
                                    <b>{formatString(k)}: </b> {typeof v === 'object' ? JSON.stringify(v) : String(v)}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <span>-</span>
                            )}
                          </TableCell>
                        </>
                      ))}
                  </TableRow>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>
      </motion.div>
      {isDrawerOpen && (
        <div className="custom-drawer">
          <div className="drawer-content">
            <SubSectionTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              Entity Details
              <Button secondary style={{ marginTop: '0' }} onClick={(e) => { setIsDrawerOpen(false); setSelectedEntity(null) }}>Cancel</Button>
            </SubSectionTitle>
            <hr />
            <JsonView src={selectedEntity} />

          </div>
        </div>
      )}
    </PageContainer>
  );
};

export default EntityRecords;
